export default __webpack_public_path__ + "b9782030cfb766b2a00333d1c9710da5.png";